<template>
  <li :class="[source.user_id == currentUserId ? 'single-item active' : 'single-item', source.is_not_follow == 1 ? 'not-follow' : '']"   :key="`left_list_${index}`" @click="viewStudent(source, index, 'left')">
    <!-- 别去掉下面一行，不知名原因导致source属性不更新到dom，导致下线的卡片不显示下线 -->
    <div v-show="false">{{source}}</div>
    <div :class="classObject(source.offLineStatus, source.handleStatus, 'left')">
      <div class="left-side" v-if="getAlarmNum(source) > 0">
        <!-- <div class="left-side"> -->
        <el-popover
          @hide="showAlarm(source.user_id)"
          @show="getAlarmItemData"
          placement="right-start"
          :width="language == 'zh' ? 790 : 890"
          popper-class="student-alarm-popper"
          trigger="hover">
          <div class="student-alarm-list" >
            <ul class="student-alarm-ul">
              <li class="first-alarm-item" v-for="(messageItem, messageIndex) in alarmItemData"
                :key="'history_' + messageIndex ">
                <AlarmItem
                  :messageItem="messageItem"
                  :item="source"
                  :showType="'list'"
                />
              </li>
            </ul>
          </div>
          <div class="photo-content" slot="reference" :style="{background: source.offLineStatus ? '#a7b2d2' : colors[index%8]}">
            <span class="name" v-if="source.real_name">{{source.real_name.slice(0, 2)}}</span>
            <span class="name" v-else-if="source.nick">{{source.nick.slice(0, 2)}}</span>
            <div class="alarm-module" v-if="alarmNum > 0">
              <span class="alarm-num">{{alarmNum}}</span>
            </div>
          </div>
        </el-popover>
      </div>
      <div class="left-side" v-else>
        <div class="photo-content" :style="{background: source.offLineStatus ? '#a7b2d2' : colors[index%8]}">
          <span class="name" v-if="source.real_name">{{source.real_name.slice(0, 2)}}</span>
          <span class="name" v-else-if="source.nick">{{source.nick.slice(0, 2)}}</span>
        </div>
      </div>
      <div class="right-side" v-if="!isCloseLeft">
        <div class="user-name-x">
          <div class="left-user-name">
            <span v-if="source.real_name" class="student-name">{{source.real_name}}</span>
            <span v-else-if="source.nick" class="student-name">{{source.nick}}</span>
            <span class="current-option" v-if="!source.offLineStatus">{{source.data[0] | getEventName(source.data[0].video_type || '')}}</span>
            <span class="current-option" v-if="source.offLineStatus">{{ $t('studentList.leftStudentItem.293515-0') }}</span>
          </div>
          <span class="wait-correct" v-if="source.data[0].correct_notify > 0">
            <i class="icon-has-zgt"></i>
          </span>
        </div>
        <p class="module" v-if="source.data[0].module_sname">【{{ getModuleName(source.data[0].module_sname) }}】{{source.data[0].tag_sname}}</p>
        <p class="module empty" v-else>--</p>
      </div>
      <div class="right-side" v-else>
        <div class="user-name-x">
          <div class="left-user-name">
            <span v-if="source.real_name" class="student-name">{{source.real_name}}</span>
            <span v-else-if="source.nick" class="student-name">{{source.nick}}</span>
          </div>
        </div>
      </div>
      <div v-if="!isCloseLeft">
        <div class="handle" v-if="!source.offLineStatus">
          <el-dropdown trigger="click">
            <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
            <el-dropdown-menu slot="dropdown" v-if="source.handleStatus == 2">
              <el-dropdown-item command="a">
                <span  style="display: block;width: 68px;text-align: center" @click="handleStudentNew(source, index, 3)">{{ $t('studentList.leftStudentItem.293515-1') }}</span>
              </el-dropdown-item>
              <el-dropdown-item command="b">
                <span  style="display:block;" @click="handleStudentNew(source, index, 1)">{{ $t('studentList.leftStudentItem.293515-2') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
            <el-dropdown-menu slot="dropdown" v-else-if="source.handleStatus == 3">
              <el-dropdown-item command="a">
                <span  style="display: block;width: 68px; text-align: center" @click="handleStudentNew(source, index, 2)">{{ $t('studentList.leftStudentItem.293515-3') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
            <el-dropdown-menu slot="dropdown" v-else-if="source.handleStatus == 1">
              <el-dropdown-item command="a">
                <span  style="display: block;width: 68px; text-align: center" @click="handleStudentNew(source, index, 2)">{{ $t('studentList.leftStudentItem.293515-4') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="handle" v-else>
          <el-dropdown trigger="click">
            <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">
                <span  style="display: block;width: 68px;text-align: center" @click="closeCardNew(source, index)">{{ $t('studentList.leftStudentItem.293515-5') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';
import Bus from '@/utils/bus.js';
import i18n from '@/i18n'
import AlarmItem from '@/components/alarmItem';
import { checkAccountDeprived } from '@/api/base';

export default {
  data() {
    return {
      colors: ['#B7A1FF', '#90DF89', '#E2BC00', '#69DAD8', '#79ACFF', '#459CD7', '#5B78D8', '#A780D8'],
      alarmLimitList: ['WARN_WRONG_ANSWER', 'WARN_ANSWER_HESITATE', 'WARN_VIDEO_END_DAZE', 'WARN_VIDEO_PLAYED_SKIP', 'WARN_VIDEO_UNPLAYED_SKIP', 'WARN_ANSWER_TOO_FAST', 'WARN_ANSWER_TOO_SLOW'],
      cTimer: null,
      alarmItemData:[],
      current: 0,
      language: 'zh',
    }
  },
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    },
    messageList: {
      type: Array,
      default() {
        return []
      },
    },
    showType: {
      type: String,
      default: 'list'
    },
    studentListCard: {
      type: Array,
      default() {
        return []
      },
    },
    setMessageDisposeStatus: {
      type: Function,
      default: () => {}
    },
    viewStudentDetail: {
      type: Function,
      default: () => {}
    },
    handleStudent: {
      type: Function,
      default: () => {}
    },
    notFollowTaOrFollow: {
      type: Function,
      default: () => {}
    },
    closeCard: {
      type: Function,
      default: () => {}
    },
  },
  components: { AlarmItem },
  computed: {
    ...mapGetters([
      'currentViewStudent',
      'currentUserId',
      'leftStudentCount',
      'pageStudentCard',
      'isCloseLeft'
    ]),
  },
  watch: {
    index: function(newVal){
      if(this.source.user_id == this.currentUserId){
        this.$nextTick(()=>{
          let currentViewStudentData = this.currentViewStudent;
          currentViewStudentData.photoColor = this.colors[typeof (this.index) != 'undefined' ? this.index % 8 : 0 % 8];
          this.$store.commit("SET_CURRENT_VIEW_STUDENT",currentViewStudentData)
        })
      }
    },
  },
  created() {
    i18n.locale = sessionStorage.getItem('Select-language') || 'zh'
    this.language = sessionStorage.getItem('Select-language') || 'zh'
  },
  mounted() {
    const vm = this
    if (typeof vm.cTimer !== 'undefined') clearInterval(vm.cTimer)
    vm.cTimer = setInterval(function() {
      vm.current = new Date().getTime()
    }, 5000)
    // Bus.$off('viewFirstStudent')
    // Bus.$on('viewFirstStudent', (isLeft) => {
    //   if (this.studentListCard.length > 0) {
    //     let newStudentArr = this.sortStudentData(this.studentListCard);
    //     let firstStudent = newStudentArr[0];
    //     this.$store.commit('SET_CURRENT_USER_ID', firstStudent['user_id']);
    //     console.log('viewStudentDetail0099')
    //     this.viewStudent(firstStudent, 0, isLeft);
    //   }
    // })
  },
  methods: {
    getModuleName (moduleName) {
      const lang = this.language
      if (lang === 'en') {
        if (moduleName === '测试') {
          return 'Test'
        }
        if (moduleName === '学习') {
          return 'Learning'
        }
        if (moduleName === '重学') {
          return 'Restudy'
        }
        if (moduleName === '补漏测') {
          return 'Knowledge gap assessment'
        }
        if (moduleName === '补漏学') {
          return 'Knowledge gap learning'
        }
        if (moduleName === '章节结束') {
          return 'Chapter ends'
        }
      }
      return moduleName
    },
    async viewStudent (val, index, isLeft) {
      try {
        const { data = {} } = await checkAccountDeprived({ account_id: val.data[0].account_id, function_id: 6266002, restrict_type: 6261003, subject_id: val.data[0].subject_id });
        const { is_limit, restrict_reason, restrict_function_name } = data
        Bus.$emit('isLimit', is_limit)
        if(is_limit){
          const message = `此学员不可使用${restrict_function_name}功能。限制原因：${restrict_reason}`
          this.$message.error(message)
          return
        }
      } catch (error) {
        console.error('Error checking function limit:', error);
      }
      const cardtop = this.studentListCard.filter(card => card.user_id == (typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''))
      if (typeof index !== 'undefined' && cardtop.length > 0) {
        cardtop[0].index = index
      } else {
        cardtop[0].index = typeof val.index !== 'undefined' ? val.index : cardtop[0].index
      }
      this.cardTop = cardtop
      const vm = this
      const user_id = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
      console.log('user_id========='+user_id);
      // debugger
      const st = vm.studentListCard.filter(event_cell => event_cell.user_id == user_id)
      // debugger
      console.log('863', st)
      const qId = (typeof st[0].data[0].question_ids !== 'undefined' && st[0].data[0].question_ids instanceof Array) ? st[0].data[0].question_ids.join(',') : ''
      console.log(qId)
      const topic_id = typeof st[0].data[0].topic_id !== 'undefined' ? st[0].data[0].topic_id : ''
      const subject_id = typeof st[0].data[0].subject_id !== 'undefined' ? st[0].data[0].subject_id : ''
      const school_id = typeof st[0].data[0].school_id !== 'undefined' ? st[0].data[0].school_id : ''
      const flow_id = typeof st[0].data[0].flow_id !== 'undefined' ? st[0].data[0].flow_id : ''
      const exam_else_info = typeof st[0].data[0].exam_else_info !== 'undefined' ? st[0].data[0].exam_else_info : ''
      const jupiter_stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
      const course_id = typeof st[0].data[0].course_id !== 'undefined' ? st[0].data[0].course_id : ''
      // const learning_version = typeof st[0].data[0].learning_version !== 'undefined' ? st[0].data[0].learning_version : ''
      const module_type = typeof st[0].data[0].module_type !== 'undefined' ? st[0].data[0].module_type : ''
      const module_name = typeof st[0].data[0].module_name !== 'undefined' ? st[0].data[0].module_name : ''
      const lesson_id = typeof st[0].data[0].lesson_id !== 'undefined' ? st[0].data[0].lesson_id : ' '
      const knowledge_code = typeof st[0].data[0].tag_code !== 'undefined' ? st[0].data[0].tag_code : ' '
      const question_bank_version = typeof st[0].data[0].question_bank_version !== 'undefined' ? st[0].data[0].question_bank_version : ''
      const question_vno = typeof st[0].data[0].question_vno !== 'undefined' ? st[0].data[0].question_vno : 0
      const account_id = val.data[0].account_id
      const stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
      const q_forms = typeof st[0].data[0].q_forms !== 'undefined' ? st[0].data[0].q_forms : ''
      const learning_version = cardtop[0]['course_version'];

      const photoColor = this.colors[typeof (index) != 'undefined' ? index % 8 : 0 % 8];
      let today_course_answer = {};
      let today_course_knowledge = {};
      let today_course_learn = {};
      let module_answer = {};
      let module_learn = {};

      let getQuestionServerTime = '';

      if (st[0].data[0].event == 'GET_QUESTION') {
        getQuestionServerTime = st[0].data[0].server_time;
      }

      if (typeof (cardtop[0].today_course_answer) !='undefined') {
        today_course_answer = cardtop[0].today_course_answer;
      }

      if (typeof (cardtop[0].today_course_knowledge) !='undefined') {
        today_course_knowledge = cardtop[0].today_course_knowledge;
      }

      if (typeof (cardtop[0].today_course_learn) !='undefined') {
        today_course_learn = cardtop[0].today_course_learn;
      }

      if (typeof (cardtop[0].module_answer) !='undefined') {
        module_answer = cardtop[0].module_answer;
      }

      if (typeof (cardtop[0].module_learn) !='undefined') {
        module_learn = cardtop[0].module_learn;
      }

      let eventMessage = '';
      if (st[0].data[0].event) {
        eventMessage = st[0].data[0].event;
      }
      this.setMessageDisposeStatus(user_id);
      this.viewStudentDetail(val, index);
      this.$store.commit("SET_CURRENT_VIEW_STUDENT", {
        exam_else_info,
        school_id,
        user_id,
        course_id,
        topic_id,
        lesson_id,
        account_id,
        knowledge_code,
        stage,
        flow_id,
        subject_id,
        jupiter_stage,
        learning_version,
        question_bank_version,
        question_vno,
        photoColor,
        qId,
        msg: '',
        eventMessage,
        module_type,
        module_name,
        today_course_answer,
        today_course_knowledge,
        today_course_learn,
        module_answer,
        module_learn,
        getQuestionServerTime,
        q_forms
      });
      this.$store.commit('SET_CURRENT_USER_ID', user_id);
      if (this.pageStudentCard['msg'] == '') { // 说明缓存里面没有值
        let tempPageStudentCard = {
          val: val,
          index: typeof index !== 'undefined' ? index : -1,
          studentListCard: this.studentListCard,
          msg: 'detail'
        }
        this.$store.commit('SET_PAGE_STUDENT_CARD', tempPageStudentCard)
      }
      if (!isLeft && this.$route.path != "/supervise/detail") {
        this.$router.push({ path: '/supervise/detail', query: {} });
      }
    },
    // 置顶/取消置顶 暂时不看他/重新关注ta
    handleStudentNew (selectItem, selectIndex, status) {

      let currentTime = new Date().getTime();
      if (!!sessionStorage.getItem('studentCardX')) { // 说明之前已经存储过学生列表的顺序了
        let studentCardX = sessionStorage.getItem('studentCardX');
        let studentCardArr = JSON.parse(studentCardX);
        // 判断当前学生是否存储过
        let findIndex =  -1;
        for (let i=0; i < studentCardArr.length; i++ ) {
          let studentCardItem = studentCardArr[i];
          if (studentCardItem['user_id'] == selectItem['user_id']) {
            findIndex = i;
            break;
          }
        }
        if (findIndex == -1) { // 说明该学生之前没有操作过置顶、不看他
          studentCardArr.push({
            user_id: selectItem['user_id'],
            handleStatus: status,
            handleTime: currentTime
          })
          sessionStorage.setItem('studentCardX', JSON.stringify(studentCardArr));
        } else { // 该学生被操作过置顶、不看他，直接从sessionStorage中移除掉
          studentCardArr.splice(findIndex, 1);
          sessionStorage.setItem('studentCardX', JSON.stringify(studentCardArr));
        }
      } else {
        let studentCardX = [];
        let firstStudent = {
          user_id: selectItem['user_id'],
          handleStatus: status,
          handleTime: currentTime
        }
        studentCardX.push(firstStudent);
        sessionStorage.setItem('studentCardX', JSON.stringify(studentCardX));
      }
      this.handleStudent(selectItem, selectIndex, status);
    },
    getAlarmItemData(){
      this.alarmItemData = this.filterMessageList(this.source, this.source.user_id)
    },
    closeCardNew(params) {
      this.closeCard(params);
    },
    classObject (offLineStatus, handleStatus, type) {
      if (type == 'left') { // 左侧列表
        if (offLineStatus) { // 离线
          return 'student-module offLine';
        } else {
          if (handleStatus == 1) { // 不关注他
            return 'student-module not-attention';
          } else { // 正常
            return 'student-module';
          }
        }
      } else { // list
        if (offLineStatus) { // 离线
          return 'single-student offLine';
        } else {
          if (handleStatus == 1) { // 不关注他
            return 'single-student not-attention';
          } else { // 正常
            return 'single-student';
          }
        }
      }
    },
    getAlarmNum (val) {
      console.log(2222228,val.data[0].event)
      const vm = this
      // let count = 0;
      //let notHandleMessageList = vm.messageList.filter(item => item.disposeStatus === false)
      //let newMessageList = this.uniqeByKeys(notHandleMessageList, ['c_time', 'user_id'])
      let newMessageList = val.data.filter(item=>this.alarmLimitList.indexOf(item.event) > -1 && item.disposeStatus === false)
      //newMessageList.forEach(item => {
        //if (val.user_id == item.user_id) {
          //count++;
        //}
      //})
      this.alarmNum = newMessageList.length;
      return newMessageList.length;
    },
    uniqeByKeys(array, keys) {
      var allArr = []
      for (var i = 0; i < array.length; i++) {
        var flag = true
        for (var j = 0; j < allArr.length; j++) {

          if (array[i].user_id === allArr[j].user_id && array[i].event === allArr[j].event && Math.abs(array[i].c_time - allArr[j].c_time) <= 1000 && !eventCheck) {
            flag = false
          }
        }
        let eventCheck = this.alarmLimitList.some((item)=>{
          return item == array[i].event
        })
        if (flag && eventCheck) {
          allArr.push(array[i])
        }
      }
      return allArr
    },
    // 显示报警，将当前的学生的报警数量设置为0
    showAlarm (user_id) {
      this.alarmItemData = [];
      this.setMessageDisposeStatus(user_id);
    },
    // 显示排序的
    sortStudentData(data) {
      let newData = data.slice();
      newData.slice().sort((a,b) => b.offLineStatus - a.offLineStatus);
      let onlineStudent = [];
      let offLineStudent = [];
      newData.map(item => {
        if (!item['offLineStatus']) { // 在线
          let lastUserName = '';
          if (item['real_name']) {
            lastUserName = item['real_name'];
          } else {
            lastUserName = item.data[0].real_sname || item.data[0].nick
          }
          item['lastUserName'] = lastUserName;
          onlineStudent.push(item);
        } else {
          let lastUserName = '';
          if (item['real_name']) {
            lastUserName = item['real_name'];
          } else {
            lastUserName = item.data[0].real_sname || item.data[0].nick
          }
          item['lastUserName'] = lastUserName;
          offLineStudent.push(item);
        }
      })
      if (!!sessionStorage.getItem('studentCardX')) {
        let studentCardXArr = JSON.parse(sessionStorage.getItem('studentCardX'));
        if (studentCardXArr.length == 0) {
          onlineStudent.map((item, index) => {
            let newItem = item;
            newItem['handleStatus'] = 2;
            this.$set(onlineStudent, index, newItem);
          })
          onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
            let studentName1 = item1['real_name'] || item1['nick'] || item1['uname'];
            let studentName2 = item2['real_name'] || item2['nick'] || item2['uname'];
            return studentName1.localeCompare(studentName2);
          });
          offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
            let studentName1 = item1['real_name'] || item1['nick'] || item1['uname'];
            let studentName2 = item2['real_name'] || item2['nick'] || item2['uname'];
            return studentName1.localeCompare(studentName2);
          });
          return onlineStudent.concat(offLineStudent);
        } else {
          let topStudentArr = [];
          let normalStudentArr = [];
          let bottomStudentArr = [];
          for (let i=0; i < onlineStudent.length; i++) {
            let dataItem = onlineStudent[i];
            let isExist = false;
            for (let j=0; j < studentCardXArr.length; j++ ) {
              let cardItem = studentCardXArr[j];
              if (dataItem['user_id'] == cardItem['user_id']) {
                isExist = true;
                if (cardItem['handleStatus'] == 1) { // 暂时不看他
                  dataItem['handleStatus'] = 1;
                  dataItem['handleTime'] = cardItem['handleTime'];
                  bottomStudentArr.push(dataItem);
                } else if (cardItem['handleStatus'] == 3) { // 置顶
                  dataItem['handleStatus'] = 3;
                  dataItem['handleTime'] = cardItem['handleTime'];
                  topStudentArr.push(dataItem);
                }
                break;
              } else {
                isExist = false;
              }
            }

            if (!isExist) {
              normalStudentArr.push(dataItem);
            }
          }
          // topStudentArr = topStudentArr.sort((a,b) => a.handleTime - b.handleTime);
          topStudentArr = topStudentArr.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          normalStudentArr = normalStudentArr.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          bottomStudentArr = bottomStudentArr.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          let lastArr = topStudentArr.concat(normalStudentArr).concat(bottomStudentArr).concat(offLineStudent);
          return lastArr
        }
      } else { // 说明之前没操作过置顶、不看他
        onlineStudent.map((item, index) => {
          let newItem = item;
          newItem['handleStatus'] = 2;
          this.$set(onlineStudent, index, newItem);
        })
        onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
          if (item1['real_name'] && item2['real_name']) {
            return item1['real_name'].localeCompare(item2['real_name']);
          }
        });
        offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
          if (item1['real_name'] && item2['real_name']) {
            return item1['real_name'].localeCompare(item2['real_name']);
          }
        });
        let lastArr = onlineStudent.concat(offLineStudent);
        return lastArr
      }
    },
    filterMessageList(messageList, user_id) {
      return messageList.data.filter(item => {
        return item.disposeStatus === false && this.alarmLimitList.indexOf(item.event) > -1;
      })
    },
  },
  filters: {
    parseTime(time) {
      if (arguments.length === 0) {
        return null
      }
      const format = '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return [i18n.t('studentList.leftStudentItem.293515-6'), i18n.t('studentList.leftStudentItem.293515-7'), i18n.t('studentList.leftStudentItem.293515-8'), i18n.t('studentList.leftStudentItem.293515-9'), i18n.t('studentList.leftStudentItem.293515-10'), i18n.t('studentList.leftStudentItem.293515-11'), i18n.t('studentList.leftStudentItem.293515-12')][value - 1]
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
    parseUserSpentTime(msd) {
      var time = parseFloat(msd) / 1000
      if (time !== null && time !== '') {
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + i18n.t('studentList.leftStudentItem.293515-13') + parseInt((parseFloat(time / 60.0) -
            parseInt(time / 60.0)) * 60) + i18n.t('studentList.leftStudentItem.293515-14')
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + i18n.t('studentList.leftStudentItem.293515-15') + parseInt((parseFloat(time / 3600.0) -
            parseInt(time / 3600.0)) * 60) + i18n.t('studentList.leftStudentItem.293515-13') +
            parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
              parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + i18n.t('studentList.leftStudentItem.293515-14')
        } else {
          if (isNaN(time)) {
            return i18n.t('studentList.leftStudentItem.293515-16')
          } else {
            if (time < 0) {
              time = 0
            }
            time = parseInt(time) + i18n.t('studentList.leftStudentItem.293515-14')
          }
        }
      }
      return time
    },
    // 卡片事件
    getEventName(val, videoType) {
      console.log(val, videoType, '例题试做调试');
      let eventName = ''
      let typeStr = ''

      if (videoType == 'IMPORT') {
        typeStr = i18n.t('studentList.leftStudentItem.293515-17');
      } else if (videoType == 'KNOWLEDGE') {
        typeStr = i18n.t('studentList.leftStudentItem.293515-18');
      } else if (videoType == 'QTID') {
        typeStr = i18n.t('studentList.leftStudentItem.293515-19');
      } else if (videoType == 'ANALYZE') {
        typeStr = i18n.t('studentList.leftStudentItem.293515-20');
      } else if (videoType == 'ERRORCAUSE') {
        typeStr = i18n.t('studentList.leftStudentItem.293515-21');
      } else if (videoType == 'SKILL') {
        typeStr = i18n.t('studentList.leftStudentItem.293515-22');
      } else if (videoType == 'QUESTION') {
        typeStr = i18n.t('studentList.leftStudentItem.293515-23');
      } else if (videoType == 'TAIL') {
        typeStr = '片尾（学习流程结束)';
      }

      switch (val.event) {
        case 'LOGIN':
          eventName = i18n.t('studentList.leftStudentItem.293515-25')
          break
        case 'RELOGIN':
          eventName = i18n.t('studentList.leftStudentItem.293515-26')
          break
        case 'MODULE_START':
          eventName = i18n.t('studentList.leftStudentItem.293515-27')
          break
        case 'GET_QUESTION':
          if (val.hasOwnProperty('question_round')) {
            if (val.question_round == 1) {
              eventName = i18n.t('studentList.leftStudentItem.293515-28')
            } else if (val.question_round == 2) {
              eventName = i18n.t('studentList.leftStudentItem.293515-29')
            }
          } else {
            eventName = i18n.t('studentList.leftStudentItem.293515-30')
          }
          break
        case 'GET_QUESTION':
          eventName = i18n.t('studentList.leftStudentItem.293515-30')
          break
        case 'SUBMIT_ANSWER':
          eventName = val.flow_id == 1000 ? '考试结束' : i18n.t('studentList.leftStudentItem.293515-31')
          break
        case 'GET_ANALYSIS':
          if (val.hasOwnProperty('question_round')) {
            if (val.question_round == 1) {
              eventName = i18n.t('studentList.leftStudentItem.293515-32')
            } else if (val.question_round == 2) {
              eventName = i18n.t('studentList.leftStudentItem.293515-33')
            }
          } else {
            eventName = i18n.t('studentList.leftStudentItem.293515-34')
          }
          break
        case 'GET_QLIST':
          eventName = i18n.t('studentList.leftStudentItem.293515-35')
          break
        case 'GET_REPORT':
          eventName = i18n.t('studentList.leftStudentItem.293515-36')
          break
        case 'VIDEO_PLAY':
        case 'EAMPLE_PROBLEM_TRIAL_DONE':
          eventName = i18n.t('studentList.leftStudentItem.293515-37') + typeStr + i18n.t('studentList.leftStudentItem.293515-38')
          break
        case 'VIDEO_CLOSE':
          eventName = i18n.t('studentList.leftStudentItem.293515-5') + typeStr + i18n.t('studentList.leftStudentItem.293515-38')
          break
        case 'VIDEO_END':
          eventName = i18n.t('studentList.leftStudentItem.293515-39')
          break
        case 'VIDEO_PAUSE':
          eventName = i18n.t('studentList.leftStudentItem.293515-40') + typeStr + i18n.t('studentList.leftStudentItem.293515-38')
          break
        case 'VIDEO_DRAG':
          eventName = i18n.t('studentList.leftStudentItem.293515-41') + typeStr + i18n.t('studentList.leftStudentItem.293515-38')
          break
        case 'VIDEO_BACK':
          eventName = i18n.t('studentList.leftStudentItem.293515-42') + typeStr + i18n.t('studentList.leftStudentItem.293515-38')
          break
        case 'VIDEO_SKIP':
          eventName = i18n.t('studentList.leftStudentItem.293515-43') + typeStr + i18n.t('studentList.leftStudentItem.293515-38')
          break
        case 'EAMPLE_PROBLEM_TRIAL_START':
        case 'EAMPLE_PROBLEM_TRIAL_CORRECTION':
          eventName = '例题试做';
          break
        case 'VIDEO_END_DAZE':
          eventName = i18n.t('studentList.leftStudentItem.293515-44')
          break
        case 'VIDEO_PAUSE_DAZE':
          eventName = i18n.t('studentList.leftStudentItem.293515-45')
          break
        case 'VIDEO_UNPLAYED_SKIP':
          eventName = i18n.t('studentList.leftStudentItem.293515-46')
          break
        case 'NO_ACTION':
          eventName = i18n.t('studentList.leftStudentItem.293515-47')
          break
        case 'WARN_VIDEO_UNPLAYED_SKIP':
          eventName = i18n.t('studentList.leftStudentItem.293515-48')
          break
        case 'WARN_VIDEO_PLAYED_SKIP':
          eventName = i18n.t('studentList.leftStudentItem.293515-49')
          break
        case 'WARN_VIDEO_PAUSE_DAZE':
          eventName = i18n.t('studentList.leftStudentItem.293515-45')
          break
        case 'WARN_VIDEO_END_DAZE':
          eventName = i18n.t('studentList.leftStudentItem.293515-44')
          break
        case 'WARN_NO_ACTION':
          eventName = i18n.t('studentList.leftStudentItem.293515-50')
          break
        case 'ANSWER_HESITATE':
          eventName = i18n.t('studentList.leftStudentItem.293515-51')
          break
        case 'WARN_ANSWER_HESITATE':
          eventName = i18n.t('studentList.leftStudentItem.293515-51')
          break
        // case 'WARN_MODULE_END':
        //   eventName = '模块完成报警'
        //   break
        case 'WARN_WRONG_ANSWER':
          eventName = i18n.t('studentList.leftStudentItem.293515-52')
          break
        case 'MODULE_END':
          eventName = i18n.t('studentList.leftStudentItem.293515-53')
          break
        case 'TAG_CODE_END':
          eventName = i18n.t('studentList.leftStudentItem.293515-54')
          break
        case 'WARN_ANSWE_TOO_SLOW':
          eventName = i18n.t('studentList.leftStudentItem.293515-55')
          break
        case 'WARN_ANSWE_TOO_FAST':
          eventName = i18n.t('studentList.leftStudentItem.293515-56')
          break
        default:
          eventName = i18n.t('studentList.leftStudentItem.293515-16')
      }
      return eventName
    },
    formatTime (s) {
      let result = '';
      if (s == 0) {
        result = i18n.t('studentList.leftStudentItem.293515-57');
      } else {
        var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整
        var hour = Math.floor( (s - day*24*3600) / 3600);
        var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 );
        var second = s - day*24*3600 - hour*3600 - minute*60;

        if (day > 0) {
          result = i18n.t('studentList.leftStudentItem.293515-58', [day])
        }

        if (hour > 0) {
          result += i18n.t('studentList.leftStudentItem.293515-59', [hour])
        }

        if (minute > 0) {
          result += i18n.t('studentList.leftStudentItem.293515-60', [minute])
        }

        if (second > 0) {
          result += i18n.t('studentList.leftStudentItem.293515-61', [second])
        }
      }
      // return day + "天"  + hour + "时" + minute + "分" + second + i18n.t('studentList.leftStudentItem.293515-14');
      return result;
    }
  },
}
</script>

<style lang="scss" scoped>
  .student-list {
    padding-bottom: 80px;
    // margin-top: 8px;
    margin-left: 11px;
    margin-bottom: 20px;
    overflow-y: auto;
    .single-item {
      position: relative;
      box-sizing: border-box;
      // height: 82px;
      .student-module {
        box-sizing: border-box;
        height: 61px;
        padding: 11px 10px 10px 6px;
        overflow: hidden;
        border-bottom: 1px solid #d3d8e8;
        display: flex;
        .left-side {
          float: left;
          width: 32px;
          height: 45px;
          margin-top: 3px;
          // padding-left: 9px;
          .photo-content {
            position: relative;
            display: flex;
            align-items: center;
            width: 32px;
            height: 32px;
            text-align: center;
            background: #69dad8;
            border-radius: 100px;
            .name {
              width: 32px;
              height: 12px;
              font-size: 12px;
              font-weight: 400;
              line-height: 12px;
              color: #fff;
            }
          }
          .alarm-module {
            top: -7px;
            right: -3px;
          }
        }
        .right-side {
          position: relative;
          float: left;
          margin-left: 12px;
          .user-name-x {
            position: relative;
            margin-bottom: 4px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(68,75,101,1);
            .left-user-name {
              position: relative;
              display: flex;
              align-items: center;
              .student-name {
                width: 60px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .wait-correct {
              position: absolute;
              right: -4px;
              top: -11px;
            }
          }
          .module {
            width: 200px;
            margin-left: -7px;
            overflow: hidden;
            font-size: 12px;
            font-weight: 400;
            color: #696f84;
            text-overflow: ellipsis;
            white-space: nowrap;
            &.empty {
              margin-left: 3px;
            }
          }
          .current-option {
            width: 133px;
            // height: 20px;
            margin-left: 8px;
            // margin-bottom: 8px;
            font-size: 12px;
            font-weight: 400;
            // line-height: 20px;
            color: #2980ff;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .jieru {
            position: absolute;
            right: -20px;
            bottom: -7px;
          }
          .answer-question-detail {
            display: flex;
            li {
              .num-rate {
                font-size: 14px;
                font-weight: 400;
                color: rgba(68,75,101,1);
                &.red {
                  color: #ff4757;
                }
              }
              .rate-text {
                font-size: 14px;
                font-weight: 400;
                color: rgba(68,75,101,.4);
              }
              &:first-child {
                margin-right: 41px;
              }
            }
          }

        }
        .handle {
          position: absolute;
          top: 12px;
          right: 8px;
          width: 40px;
          height: 40px;
        }
        &.not-attention {
          background: #f3f6fd;
        }
        &.offLine {
          background: #f5f5f5;
        }
      }
      &:last-child {
        border-bottom: none;
      }
      // .wait-correct {
      //   position: absolute;
      //   top: 0;
      //   right: 0;
      // }
      &.active {
        background: #F3F6FD;
      }
      &.not-follow {
        background: #f5f8ff;
        .student-module {
          .right-side {
            .user-name-x {
              color: #a7b2d2;
            }
            .module {
              color: #a7b2d2;
            }
            .current-option {
              color: #a7b2d2;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/studentList/leftStudentItem.vue